import { BrowserRouter, Route, Routes as Switch } from 'react-router-dom'
import Forgot from '../pages/Auth/Forgot'
import ForgotChangePassword from '../pages/Auth/ForgotChangePassword'
import Login from '../pages/Auth/Login'
import Register from '../pages/Auth/Register'
import Home from '../pages/Dashboard/Home'
import Users from '../pages/Dashboard/Users'
import NotFound from '../pages/NotFound'
import Profile from '../pages/Profile'
import AuthRoute from './AuthRoute'
import PrivateRoute from './PrivateRoute'
import Logs from '../pages/Dashboard/Logs'
import Documents from '../pages/Dashboard/Documents'
import DocumentView from '../pages/Dashboard/DocumentView'
import DocumentTypes from '../pages/Dashboard/DocumentTypes'
import Groups from '../pages/Dashboard/Groups'
import Reports from '../pages/Dashboard/Reports'
import ApiIntegration from '../pages/Dashboard/ApiIntegration'
import PublicDocumentView from '../pages/PublicDocumentView'
import PrintQRCode from '../pages/PrintQRCode'

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path='/public/document/:id' element={<PublicDocumentView />} />
      <Route path='/print/qrcode/:id' element={<PrintQRCode />} />
      <Route path='/' element={<PrivateRoute fullPage Component={Home} />} />
      <Route path='/users' element={<PrivateRoute fullPage Component={Users} />} />
      <Route path='/groups' element={<PrivateRoute fullPage Component={Groups} />} />
      <Route path='/logs' element={<PrivateRoute fullPage Component={Logs} />} />
      <Route path='/reports' element={<PrivateRoute fullPage Component={Reports} />} />
      <Route path='/api-integration' element={<PrivateRoute fullPage Component={ApiIntegration} />} />
      <Route path='/documentTypes' element={<PrivateRoute fullPage Component={DocumentTypes} />} />
      <Route path='/documents' element={<PrivateRoute fullPage Component={Documents} />} />
      <Route path='/document/:id' element={<PrivateRoute fullPage Component={DocumentView} />} />
      
      <Route path='/config' element={<PrivateRoute fullPage Component={Profile} />} />
      <Route path='/login' element={<AuthRoute Component={Login} />} />
      <Route path='/register' element={<AuthRoute Component={Register} />} />
      <Route path='/forgot' element={<AuthRoute Component={Forgot} />} />
      <Route
        path='/forgot-password/:token'
        element={<AuthRoute Component={ForgotChangePassword} />}
      />

      <Route path='*' element={<AuthRoute Component={NotFound} />} />
    </Switch>
  </BrowserRouter>
)

export default Routes
